import React from 'react';


/**
 * Match Info Widget:
 * Competition, Venue, and Attendance
 */
const MatchInfoWidget = (props) => {
    const { 
        competition = '', 
        competitionUrl = '', 
        venue = '', 
        attendance = '', 
        ...restProps 
    } = props;


    return (
        <div className="acaWidget acaWidget--matchInfo">
            <div className="acaWidget__inner">
                { competition ? (
                    <div className="acaWidgetItem acaWidgetItem--competition">
                        <h5 className="acaH5 acaWidgetItem__title">Competition</h5>
                        <div className="acaH4 acaWidgetItem__content">
                            {competition} <i className="fa-solid fa-arrow-up-right-from-square"></i>
                        </div>
                    </div>
                ) : '' }
                { venue ? (
                    <div className="acaWidgetItem acaWidgetItem--venue">
                        <h5 className="acaH5 acaWidgetItem__title">Venue</h5>
                        <div className="acaH4 acaWidgetItem__content">{venue}</div>
                    </div>
                ) : '' }
                { attendance ? (
                    <div className="acaWidgetItem acaWidgetItem--attendance">
                        <h5 className="acaH5 acaWidgetItem__title">Attendance</h5>
                        <div className="acaH4 acaWidgetItem__content">{attendance}</div>
                    </div>
                ) : '' }
            </div>
        </div>
    );
}





/**
 * Export
 */
export { MatchInfoWidget };

